export default function (state = false, action) {
  switch (true) {
    case action.type === 'SUBMIT_AGREEMENTS_SUCCESS':
      return true;
    default:
      return state;
  }
}
